"use client";

import { useAuth } from "@clerk/nextjs";
import { useIsAdmin } from "./use-is-admin";

export function useProStatus() {
  const { has, isLoaded } = useAuth();
  const isAdmin = useIsAdmin();
  if (isAdmin) return true;
  if (!isLoaded) return false;
  return has?.({ plan: "pro" }) ?? false;
}
